import React from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import styles from './DefaultTooltipContent.module.css';
export var TooltipSize;
(function (TooltipSize) {
    TooltipSize["Large"] = "large";
    TooltipSize["Small"] = "small";
})(TooltipSize || (TooltipSize = {}));
export var TooltipMode;
(function (TooltipMode) {
    TooltipMode["Light"] = "light";
    TooltipMode["Dark"] = "dark";
})(TooltipMode || (TooltipMode = {}));
const TooltipContent = ({ headline, headlineIcon, contentText, tooltipSize, tooltipMode }) => (React.createElement("div", { className: tooltipSize === TooltipSize.Large
        ? styles.component
        : styles.componentSmall },
    headline && (React.createElement(Text, { className: styles.headline, size: tooltipSize === TooltipSize.Large ? TextSize.M : TextSize.XXS, color: tooltipMode === TooltipMode.Dark ? 'neutral-800' : 'neutral-100', bold: true },
        headlineIcon && (React.createElement("div", { className: cx(styles.headlineIcon, tooltipSize === TooltipSize.Small && styles.smallIcon) }, headlineIcon)),
        headline)),
    contentText && (React.createElement(Text, { size: tooltipSize === TooltipSize.Large ? TextSize.XS : TextSize.XXS, color: tooltipMode === TooltipMode.Dark ? 'neutral-400' : 'neutral-100' }, contentText))));
export default TooltipContent;
//# sourceMappingURL=DefaultTooltipContent.js.map